export const version = "transactions/5.3.0";
//# sourceMappingURL=_version.js.map